/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";
import smoothscroll from "smoothscroll-polyfill";

/*------------------------------------*\
    EXAMPLE MODULE
\*------------------------------------*/
class BackToTop {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        // Inititialise polyfill for browsers with no nativesupport for smooth scroll
        smoothscroll.polyfill();

        let backToTop = document.querySelector('.site-foot__subcontainer-bottom-right-button');
        let body = document.querySelector('body');

        function addAnimation(evt) {
            evt.preventDefault();
            window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
        }



        backToTop.addEventListener("click", addAnimation);

    }
}

export default BackToTop;
